import { Pipe, PipeTransform } from '@angular/core';

import { differenceInYears, isDate } from 'date-fns';

@Pipe({
    name: 'age'
})
export class AgePipe implements PipeTransform {
    transform(value: any) {
        if (!value) { return null; }

        const birthdate = new Date(value);
        if (!isDate(birthdate)) { return value; }

        const ageval = differenceInYears(new Date(), birthdate);

        return ageval;
    }
}
